/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./Community.css";
import { useNavigate, Link } from "react-router-dom";
import {
  fetchCommunityData,
  fetchCommunityDatabyClaimStatus,
  fetchCommunityDataByUserIdClaimStatus,
  deleteCommunityByClaimStatus,
  fetchCommunityHomeownerData,
} from "../../../Services/Community/CommunityAPI/communityApi";
import {
  addMultipleHomeOwners,
  updateHomeOwnerDataApi,
} from "../../../Services/Homeowner/HomeownerApi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box } from "@mui/material";
import { claimCommunity } from "../../../Services/Community/ClaimCommunity/claimCommunityApi";
import { capitalizeWords } from "../../../Utils/LetterCase";
import PaginationComponent from "../../Pagination/pagination";
import Modal from "react-bootstrap/Modal";
import * as Papa from "papaparse";
import { encryptId } from "../../../Utils/Crypto";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";
import {
  fetchProductList,
  createNewSubscription,
} from "../../../Services/Subscription/subscriptionApi";
import { ThreeDot } from "react-loading-indicators";

function MyVerticallyCenteredModal(props) {
  const [selectedFile, setSelectedFile] = useState();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  const [bulkEmails, setBulkEmails] = useState([]);
  const dispatch = useDispatch();
  const { data, loading } = useSelector(
    (state) => state.fetchCommunityHomeowner
  );
  const [refetch, setRefetch] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const id = props.id;

  const handleSelFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) handleBulkEmailUpload(selectedFile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFile]);

  useEffect(() => {
    if (id)
      dispatch(
        fetchCommunityHomeownerData({
          id: id,
          page: page,
          page_size: pageSize,
          search: search,
        })
      );
  }, [dispatch, page, pageSize, id, search]);

  useEffect(() => {
    if (data) {
      setCount(data?.data?.count);
    }
  }, [data, refetch]);

  const handleBulkHomeOwner = async () => {
    props.onHide();
    const payload = {
      community_id: id,
      home_owners: bulkEmails,
    };
    if (bulkEmails.length > 0) {
      try {
        const response = await dispatch(
          addMultipleHomeOwners(payload)
        ).unwrap();

        if (response?.status === 201) {
          toast.success("HomeOwner assigned to community successfully!");
        }
      } catch (err) {
        toast.error(
          `HomeOwner assign community failed! ${
            err.message || "Please try again later."
          }`
        );
      } finally {
        setBulkEmails([]);
        setSelectedFile(null);
        dispatch(
          fetchCommunityHomeownerData({
            id: id,
            page: page,
            page_size: pageSize,
            search: search,
          })
        );
        // setSelectedFile(null)
      }
    } else {
      return toast.error("Please upload a file or enter emails.");
    }
  };

  const handleBulkEmailUpload = async (selectedFile) => {
    if (selectedFile) {
      try {
        const fileReader = new FileReader();

        fileReader.onload = async (e) => {
          const csvData = e.target.result;

          const { data } = await new Promise((resolve, reject) => {
            Papa.parse(csvData, {
              header: true,
              complete: (results) => resolve(results),
              error: (error) =>
                reject(new Error(error.message || "CSV parsing error")),
            });
          });

          const extractedEmails = data
            .map((row) => {
              // Case-insensitive email column search
              const emailKey = Object.keys(row).find((key) =>
                /^(e-?)?mail$/i.test(key)
              );

              // Trim and filter out empty or invalid emails using emailRegex
              const email = emailKey ? row[emailKey].trim() : null;

              return email && emailRegex.test(email) ? email : null; // Only valid emails
            })
            .filter((email) => email !== null);
          setBulkEmails(extractedEmails);
        };

        fileReader.readAsText(selectedFile);
      } catch (error) {
        console.error("Error reading or parsing file:", error);
      }
    } else {
      alert("Please select a file.");
    }
  };

  const handleRemove = async (id) => {
    if (!id) return;

    try {
      await dispatch(updateHomeOwnerDataApi(id)).unwrap();
      setRefetch(true);
      toast.success("Homeowner removed successfully!");
      dispatch(
        fetchCommunityHomeownerData({
          id: id,
          page: page,
          page_size: pageSize,
          search: search,
        })
      );
    } catch (error) {
      toast.error(
        `Failed to remove homeowner. ${error.message || "Please try again."}`
      );
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="homeowner-modal"
      backdrop="static"
    >
      <Modal.Header
        closeButton
        onClick={() => {
          setBulkEmails([]);
          setSelectedFile(null);
          setSearch("");
          setPage(1);
          setPageSize(5);
        }}
        className="pb-0"
      ></Modal.Header>
      <Modal.Body>
        <h4 className="text-center">Homeowners</h4>
        <div className="d-flex align-items-center justify-content-between gap-3 resident-wrapper">
          <div className="resident-block input-searchbar-community">
            <div className="new-resident">Add New Resident</div>
            <input
              type="text"
              id="textInput"
              className="email-input home-owner-input"
              placeholder="Enter Emails"
              value={selectedFile ? null : bulkEmails}
              onChange={(event) => setBulkEmails([event.target.value])}
            />
          </div>
          <div className="resident-block">
            <div className="new-resident bulk">Bulk Upload (.csv file)</div>
            <div className="gap-3 choose-file-ai ai-training">
              <input
                type="file"
                id="fileInput"
                className="file-input"
                accept=".csv"
                onChange={handleSelFileChange}
              />
              <label
                htmlFor="fileInput"
                className="custom-file-button orange-filled-btn claimbtn mt-0 file-choose"
              >
                Choose File
              </label>
            </div>
            {selectedFile && (
              <div className="uploaded-file mt-2">
                <p className="mb-0">
                  <strong>Uploaded File:</strong> {selectedFile.name}
                </p>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="text-center mt-3 mb-3">
            <button
              className="orange-filled-btn claimbtn"
              onClick={handleBulkHomeOwner}
            >
              Submit
            </button>
          </div>
        </div>
        <div className="community-section p-0">
          <div className="all-commmunities-table">
            <div className="inner-wrap-all">
              <div className="title-search-block d-flex justify-content-between align-items-center">
                <div className="allcommunities">Homeowners</div>
                <div className="searchbar">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="inputsearch"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
              <div className="community-name-table communityblk">
                <div className="table-inner">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Email</th>
                        <th scope="col">Address</th>
                        {/* <th scope="col">Status</th> */}
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading &&
                      Array.isArray(data?.data?.data) &&
                      data?.data?.data?.length > 0 ? (
                        data?.data?.data?.map((person, index) => (
                          <tr key={person.id}>
                            <td>
                              {person?.user_details
                                ? `${person?.user_details?.first_name} ${person?.user_details?.last_name}`
                                : "-"}
                            </td>
                            <td>
                              {person?.user_details
                                ? person?.user_details?.phone_number
                                : "-"}
                            </td>
                            <td>{person?.email}</td>
                            <td>
                              {person?.user_details ? (
                                <>
                                  {person?.user_details?.bldg_suite_unit &&
                                    `${person?.user_details?.bldg_suite_unit}, `}
                                  {person?.user_details?.address},{" "}
                                  {person?.user_details?.city},{" "}
                                  {person?.user_details?.state}{" "}
                                  {person?.user_details?.zipcode}
                                </>
                              ) : (
                                "-"
                              )}
                            </td>
                            {/* <td>
                            <div className="d-flex align-items-center gap-1">
                              {renderButtons("pending"
                              )}
                            </div>
                          </td> */}
                            <td>
                              <button
                                className="orange-filled-btn claimbtn "
                                onClick={() => handleRemove(person?.id)}
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>No records found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <PaginationComponent
                    count={count}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
function CommunityComp() {
  const [modalShow, setModalShow] = React.useState(false);
  const [id, setId] = useState("");
  const [currentId, setcurrentId] = useState();
  const [page, setPage] = useState(1); // Initialize to page 1
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [amPage, setAmPage] = useState(1); // Initialize to page 1
  const [amPageSize, setAmPageSize] = useState(10); // Default page size
  const [count, setCount] = useState();
  const [amCommunityCount, setAmCommunityCount] = useState();
  const [refetch, setRefetch] = useState(false);
  const [all_community_claim, setall_community_claim] = useState();
  const [communityByClaimStatus, setcommunityByClaimStatus] = useState();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const allcommunityClaim = useSelector(
    (state) => state.fetchCommunityDatabyClaimStatus.data
  );
  const allcommunityByUserIdClaim = useSelector(
    (state) => state.fetchCommunityDataByUserIdClaimStatus.data
  );
  const allcommunityByUserIdClaimLoading = useSelector(
    (state) => state.fetchCommunityDataByUserIdClaimStatus.loading
  );
  const { loading: addmholoading } = useSelector(
    (state) => state.addMultipleHomeOwners
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [selectedCommunityId, setSelectedCommunityId] = useState(null);
  const user_id = localStorage.getItem("user_id");
  const [isLoading, setIsLoading] = useState(false);
  const userId = localStorage.getItem("user_id");
  const [search, setSearch] = useState(""); // <-- Add search state
  const [formData, setFormData] = useState({
    claim_by_current_user_id: user_id,
    claim_for_community_id: selectedCommunityId,
    doc_file: [],
    description: "",
  });
  const [selectedProductId, setSelectedProductId] = useState(null);

  const { data: productList } = useSelector((state) => state.fetchProductList);
  const products = productList?.data || [];
  const securedDocProduct = products.find(
    (item) => item.metadata.Type.role === "secured_document_portal"
  );
  const complianceProduct = products.find(
    (item) => item.metadata.Type.role === "compliance_monitoring"
  );

  const [inputValue, setInputValue] = useState("");
  const [emails, setEmails] = useState([]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  const { data: profileData } = useSelector(
    (state) => state.fetchProfileData.data
  );
  const handleRemoveEmail = (index) => {
    setEmails((prevEmails) => prevEmails.filter((_, i) => i !== index));
  };
  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value); // Only update input value, no email validation here
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const emailsToAdd = inputValue
        .split(",") // Split by commas
        .map((email) => email.trim()) // Remove extra spaces
        .filter((email) => emailRegex.test(email) && !emails.includes(email)); // Validate and check for duplicates

      if (emailsToAdd.length > 0) {
        setEmails((prevEmails) => [...prevEmails, ...emailsToAdd]); // Add valid emails
        setInputValue(""); // Clear input after adding emails
      }
    }
  };

  const handleSelFileChange = (event) => {};

  const handleHomeOwner = async (id) => {
    const payload = {
      community_id: id,
      home_owners: emails,
    };

    try {
      const response = await dispatch(addMultipleHomeOwners(payload)).unwrap();

      if (response?.status === 201) {
        toast.success("HomeOwner assigned to community successfully!");
      }
    } catch (err) {
      toast.error(
        `HomeOwner assign community failed! ${
          err.message || "Please try again later."
        }`
      );
    } finally {
      setInputValue(""); // Clear email input
      setEmails([]);
    }
  };

  useEffect(() => {
    dispatch(fetchCommunityData()).finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      fetchCommunityDatabyClaimStatus({ page, page_size: pageSize, search })
    ).finally(() => {
      setLoading(false);
      setRefetch(false);
    });
  }, [dispatch, page, pageSize, search, refetch]);

  useEffect(() => {
    if (allcommunityClaim) {
      setall_community_claim(allcommunityClaim?.data?.data);
      setCount(allcommunityClaim?.data?.count);
    }
  }, [allcommunityClaim]);

  //community by user id with claimid
  useEffect(() => {
    dispatch(
      fetchCommunityDataByUserIdClaimStatus({
        userId: userId,
        page: amPage,
        page_size: amPageSize,
      })
    ).finally(() => {
      setLoading(false);
      setRefetch(false);
    });
  }, [dispatch, refetch, userId, amPage, amPageSize]);

  useEffect(() => {
    if (allcommunityByUserIdClaim) {
      setcommunityByClaimStatus(allcommunityByUserIdClaim?.data);
      setAmCommunityCount(allcommunityByUserIdClaim?.data?.count);
    }
  }, [allcommunityByUserIdClaim]);

  const confirmDelete = async () => {
    try {
      await dispatch(deleteCommunityByClaimStatus(currentId)).unwrap();
      toast.success("Community deleted successfully");
      setRefetch(true);
    } catch (error) {
      console.error("Error deleting community:", error);
      toast.error("Failed to delete community");
    }
  };

  const handlemodel = (id) => {
    setcurrentId(id);
  };

  const closeModal = () => {};

  if (loading)
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "75vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#e55426" size="small" text="" textColor="" />
        </Box>
      </div>
    );

  const handleSubmit = async (community_id) => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("claim_by_current_user_id", user_id);
      formDataToSend.append("claim_for_community_id", community_id);
      formDataToSend.append("status", "pending");
      formData.doc_file.forEach((file) => {
        formDataToSend.append("doc_file", []);
      });
      formDataToSend.append("description", "");

      dispatch(claimCommunity(formDataToSend))
        .unwrap()
        .then((res) => {
          setRefetch(true);
          toast.success(res.message);
          setFormData({
            claim_by_current_user_id: "",
            claim_for_community_id: "",
            doc_file: [],
            description: "",
          });
          setIsLoading(false); // Reset loading state
        })
        .catch((err) => {
          toast.error(err.message);
          setIsLoading(false); // Reset loading state in case of an error
        });
    } catch (error) {
      console.error("Error submitting form:", error);
      setIsLoading(false); // Reset loading state in case of an error
    }
  };

  const renderButtons = (status) => {
    if (status === "accept") {
      return (
        // <button
        //   type="button"
        //   className="btn btn-success no-hover"
        //   style={{ cursor: "default" }}
        // >
        //   Accepted
        // </button>
        <span
          className="badge rounded-pill text-bg-success"
          style={{ cursor: "default" }}
        >
          Accepted
        </span>
      );
    } else if (status === "pending") {
      return (
        // <button
        //   type="button"
        //   className="btn btn-warning no-hover"
        //   style={{ cursor: "default" }}
        // >
        //   Pending
        // </button>
        <span
          className="badge rounded-pill text-bg-warning"
          style={{ cursor: "default" }}
        >
          Pending
        </span>
      );
    } else {
      return null; // No button for other statuses
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="deleteCommunityModal"
        tabIndex="-1"
        aria-labelledby="addCommunityModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addCommunityModalLabel">
                Delete Community
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <label htmlFor="communitySelect" className="form-label m-0">
                Are you sure you want to delete?
              </label>
            </div>
            <div className="modal-footer community-footer">
              <button
                type="button"
                className="bttn-close"
                data-bs-dismiss="modal"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                type="button"
                className="bttn-upload"
                data-bs-dismiss="modal"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading">My Communities</div>
            <button
              className="orange-filled-btn addcommunitybtn"
              onClick={() => navigate("/admin/create-community")}
            >
              Add New Community
            </button>
          </div>
          <div className="community-name-table">
            <div className="community-tabs-section d-none"></div>
            <div className="training-ai-blk">
              <div className="tab-content mt-3">
                <div className="contact-content  mt-4 training-ai-block">
                  <div className="contact-us-block-form text-start">
                    <div className="table-inner">
                      {allcommunityByUserIdClaimLoading ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center", // Centers horizontally
                            alignItems: "center", // Centers vertically
                            minHeight: "25vh",
                            textAlign: "center",
                            width: "100%", // Ensures it spans the full width
                          }}
                        >
                          <ThreeDot
                            color="#e55426"
                            size="small"
                            text=""
                            textColor=""
                          />
                        </Box>
                      ) : (
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Community Name</th>
                              <th scope="col">City</th>
                              <th scope="col">State</th>
                              <th scope="col">Type</th>
                              <th scope="col" className="units-th">
                                Units
                              </th>
                              <th scope="col">Status</th>
                              {/* <th scope="col">Community Verification</th> */}
                              <th scope="col">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {communityByClaimStatus &&
                            communityByClaimStatus?.data?.length > 0 ? (
                              communityByClaimStatus?.data?.map(
                                (community, index) => (
                                  <tr key={community.id}>
                                    <td>
                                      {capitalizeWords(
                                        community?.community?.community_name
                                      )}
                                    </td>
                                    <td>
                                      {community?.community?.location?.city}
                                    </td>
                                    <td>
                                      {community?.community?.location?.state}
                                    </td>
                                    <td>{community?.community?.type}</td>
                                    <td>{community?.community?.unit}</td>
                                    <td>
                                      <div className="d-flex align-items-center gap-1">
                                        {renderButtons(
                                          community.status === "accept" &&
                                            community?.community
                                              ?.approval_status === "approved"
                                            ? "accept"
                                            : "pending"
                                        )}
                                        <Tooltip
                                          title={
                                            community?.status === "accept" &&
                                            community?.community
                                              ?.approval_status === "approved"
                                              ? "Your claim and approval request is accepted."
                                              : community?.status ===
                                                  "pending" &&
                                                community?.community
                                                  ?.approval_status ===
                                                  "approved"
                                              ? "Your claim request is still pending."
                                              : "Your approval request is still pending."
                                          }
                                          arrow
                                        >
                                          <span style={{ cursor: "pointer" }}>
                                            <InfoOutlinedIcon fontSize="small" />
                                          </span>
                                        </Tooltip>
                                      </div>
                                    </td>
                                    {/* <td>
                                        {" "}
                                        {renderApprovalButtons(
                                          community?.community?.approval_status
                                        )}
                                        <span
                                          style={{ marginLeft: "10px" }}
                                        ></span>
                                      </td> */}

                                    <td>
                                      <div className="d-flex gap-2">
                                        {community.status !== "pending" ? (
                                          <a
                                            title="Edit"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="edit"
                                              onClick={() => {
                                                navigate(
                                                  "/admin/update-community",
                                                  {
                                                    state: {
                                                      communityId:
                                                        community?.community
                                                          ?.id,
                                                    },
                                                  }
                                                );
                                              }}
                                            >
                                              <svg
                                                width="14"
                                                height="14"
                                                viewBox="0 0 13 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g clipPath="url(#clip0_101_3493)">
                                                  <path
                                                    d="M11.9985 8.63379C11.8196 8.63379 11.6747 8.77871 11.6747 8.95756V11.8323C11.6741 12.3685 11.2396 12.803 10.7034 12.8036H1.61884C1.08258 12.803 0.648182 12.3685 0.647534 11.8323V3.3952C0.648182 2.85908 1.08261 2.42455 1.61884 2.4239H4.49357C4.67238 2.4239 4.81733 2.27895 4.81733 2.10013C4.81733 1.92141 4.67238 1.77637 4.49357 1.77637H1.61884C0.725174 1.77737 0.00100368 2.50154 0 3.3952V11.8324C0.00100368 12.726 0.725174 13.4502 1.61884 13.4512H10.7034C11.5971 13.4502 12.3213 12.726 12.3223 11.8324V8.95756C12.3223 8.77871 12.1773 8.63379 11.9985 8.63379Z"
                                                    fill="#000000"
                                                  />
                                                  <path
                                                    d="M12.1943 0.943343C11.6253 0.374354 10.7028 0.374354 10.1338 0.943343L4.35758 6.71958C4.31804 6.75911 4.28942 6.80821 4.2745 6.8621L3.51491 9.60441C3.49958 9.65962 3.49918 9.71792 3.51376 9.77334C3.52834 9.82875 3.55736 9.87931 3.59788 9.91983C3.63839 9.96036 3.68893 9.9894 3.74435 10.004C3.79976 10.0186 3.85806 10.0182 3.91327 10.0029L6.65558 9.24318C6.70947 9.22826 6.75857 9.19964 6.79811 9.1601L12.5742 3.38377C13.1423 2.81436 13.1423 1.89266 12.5742 1.32328L12.1943 0.943343ZM5.06304 6.93003L9.79046 2.20251L11.3151 3.72713L6.58756 8.45465L5.06304 6.93003ZM4.7585 7.54114L5.97651 8.75931L4.29169 9.22612L4.7585 7.54114ZM12.1164 2.92593L11.773 3.26925L10.2483 1.74451L10.5918 1.40115C10.9078 1.08509 11.4203 1.08509 11.7363 1.40115L12.1164 1.78106C12.4319 2.09751 12.4319 2.60961 12.1164 2.92593Z"
                                                    fill="#000000"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_101_3493">
                                                    <rect
                                                      width="13"
                                                      height="13"
                                                      fill="white"
                                                      transform="translate(0 0.5)"
                                                    />
                                                  </clipPath>
                                                </defs>
                                                <circle
                                                  cx="100"
                                                  cy="100"
                                                  r="50"
                                                  stroke="black"
                                                  strokeWidth="3"
                                                  fill="blue"
                                                >
                                                  <title>Circle Tooltip</title>
                                                </circle>
                                              </svg>
                                            </div>
                                          </a>
                                        ) : null}

                                        <a
                                          style={{ cursor: "pointer" }}
                                          title="Profile"
                                        >
                                          <div
                                            className="view-icon-eye"
                                            onClick={() => {
                                              const queryParams =
                                                new URLSearchParams({
                                                  status: community.status,
                                                  approvalStatus:
                                                    community?.community
                                                      ?.approval_status,
                                                }).toString();
                                              navigate(
                                                `/admin/tab/${encryptId(
                                                  community?.community?.id
                                                )}?${queryParams}`
                                              );
                                            }}
                                          >
                                            <svg
                                              width="15"
                                              height="14"
                                              viewBox="0 0 23 14"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M11.2772 7.20095L11.2775 7.20124C11.3939 7.3299 11.5511 7.37848 11.6814 7.39721C11.8148 7.41637 11.9605 7.41017 12.1008 7.39443C12.3541 7.36601 12.647 7.29888 12.913 7.23793C12.9403 7.23166 12.9674 7.22546 12.9941 7.21937C13.2974 7.15023 13.5476 7.09773 13.7196 7.09394C13.7326 7.09365 13.7442 7.09369 13.7544 7.09395C13.7039 8.25914 12.7191 9.20018 11.5 9.20018C10.2472 9.20018 9.24355 8.20822 9.24355 7C9.24355 5.80607 10.2236 4.82332 11.4557 4.80024C11.4558 4.80514 11.4559 4.81046 11.4558 4.81623C11.4552 4.96226 11.401 5.18477 11.3211 5.47591C11.3128 5.50623 11.3042 5.53716 11.2955 5.56858C11.2267 5.81731 11.1493 6.09697 11.1129 6.34728C11.0922 6.48979 11.082 6.63906 11.0991 6.77985C11.1162 6.92086 11.1636 7.07498 11.2772 7.20095ZM0.3 7C0.3 6.99221 0.303779 6.95415 0.330103 6.87721C0.354936 6.80463 0.394591 6.71243 0.451398 6.60209C0.564888 6.38165 0.7391 6.10377 0.975787 5.78837C1.44872 5.15817 2.16041 4.3924 3.10559 3.65187C4.99442 2.17201 7.80594 0.8 11.5 0.8C15.1935 0.8 18.005 2.172 19.894 3.65187C20.8392 4.39241 21.551 5.15819 22.0241 5.78839C22.2608 6.10379 22.4351 6.38167 22.5486 6.60211C22.6054 6.71245 22.6451 6.80466 22.6699 6.87724C22.6962 6.95417 22.7 6.99222 22.7 7C22.7 7.00045 22.7 6.99965 22.7 7.00016C22.7 7.00069 22.7 7.00003 22.7 7.00063L22.6999 7.00247L22.6992 7.00951C22.6985 7.01572 22.6971 7.02421 22.6948 7.03514C22.6902 7.05728 22.6823 7.0862 22.6699 7.12227C22.6451 7.19475 22.6054 7.28687 22.5486 7.39715C22.4351 7.61745 22.2608 7.89525 22.0241 8.21061C21.551 8.84073 20.8392 9.60659 19.894 10.3473C18.005 11.8274 15.1934 13.2 11.5 13.2C7.80598 13.2 4.99446 11.8274 3.10561 10.3473C2.16042 9.6066 1.44872 8.84074 0.975773 8.21063C0.739078 7.89528 0.564857 7.61748 0.451361 7.39717C0.39455 7.2869 0.354896 7.19478 0.330067 7.1223C0.31771 7.08622 0.309813 7.0573 0.305159 7.03515C0.30286 7.02422 0.301521 7.01574 0.300779 7.00952L0.300108 7.00248L0.300014 7.00063C0.299992 7.00003 0.300008 7.00069 0.300002 7.00016C0.29999 6.99965 0.299997 7.00045 0.3 7ZM6.08825 7C6.08825 9.9333 8.51741 12.2992 11.5 12.2992C14.4827 12.2992 16.9106 9.93321 16.9106 7C16.9106 4.06697 14.4829 1.69848 11.5 1.69848C8.51722 1.69848 6.08825 4.06688 6.08825 7Z"
                                                stroke="#000000"
                                                strokeWidth="0.6"
                                              />
                                            </svg>
                                          </div>
                                        </a>

                                        {community.status !== "pending" ? (
                                          <Link title="Delete">
                                            <div
                                              className="dustbin-icon"
                                              data-bs-toggle="modal"
                                              data-bs-target="#deleteCommunityModal"
                                              onClick={() =>
                                                handlemodel(community?.id)
                                              }
                                            >
                                              <svg
                                                width="14"
                                                height="14"
                                                viewBox="0 0 13 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M11.7296 2.35905H9.65408V2.06273C9.65408 1.36769 9.08864 0.802246 8.3936 0.802246H4.6064C3.91136 0.802246 3.34592 1.36769 3.34592 2.06273V2.35905H1.2704C1.00895 2.35934 0.758291 2.46332 0.573404 2.64818C0.388517 2.83304 0.284496 3.08368 0.284157 3.34513V3.81265C0.284157 4.32161 0.671837 4.74161 1.1672 4.79345L2.18272 13.7048C2.27952 14.5558 2.99872 15.1976 3.85536 15.1976H9.14448C10.0011 15.1976 10.7203 14.5558 10.8171 13.7048L11.8326 4.79345C12.0749 4.76767 12.2991 4.65326 12.4621 4.47222C12.6251 4.29117 12.7154 4.05626 12.7157 3.81265V3.34513C12.7153 3.08368 12.6113 2.83304 12.4264 2.64818C12.2415 2.46332 11.991 2.35934 11.7296 2.35905ZM3.98608 2.06273C3.98625 1.89822 4.05167 1.74049 4.168 1.62417C4.28432 1.50784 4.44205 1.44242 4.60656 1.44225H8.39376C8.55827 1.44242 8.71599 1.50784 8.83231 1.62417C8.94864 1.74049 9.01407 1.89822 9.01424 2.06273V2.35905H3.98608V2.06273ZM10.1814 13.6323C10.1526 13.887 10.0309 14.1221 9.8397 14.2928C9.64848 14.4635 9.4011 14.5577 9.1448 14.5576H3.85568C3.59937 14.5577 3.35199 14.4635 3.16078 14.2928C2.96956 14.1221 2.8479 13.887 2.81904 13.6323L1.81248 4.79889H11.1882L10.1814 13.6323ZM12.076 3.81265C12.0759 3.90444 12.0393 3.99243 11.9744 4.05733C11.9095 4.12224 11.8215 4.15876 11.7298 4.15889H1.2704C1.17861 4.15876 1.09061 4.12224 1.02571 4.05733C0.960803 3.99243 0.924284 3.90444 0.924157 3.81265V3.34513C0.924157 3.15441 1.07952 2.99905 1.2704 2.99905H11.7294C11.9203 2.99905 12.0757 3.15441 12.0757 3.34513V3.81265H12.076Z"
                                                  fill="#000000"
                                                />
                                                <path
                                                  d="M6.5 12.8257C6.58487 12.8257 6.66626 12.792 6.72627 12.732C6.78628 12.672 6.82 12.5906 6.82 12.5057V6.85101C6.82 6.76614 6.78628 6.68474 6.72627 6.62473C6.66626 6.56472 6.58487 6.53101 6.5 6.53101C6.41513 6.53101 6.33373 6.56472 6.27372 6.62473C6.21371 6.68474 6.18 6.76614 6.18 6.85101V12.5057C6.18 12.5906 6.21371 12.672 6.27372 12.732C6.33373 12.792 6.41513 12.8257 6.5 12.8257ZM8.41296 12.8108C8.45478 12.815 8.49699 12.8108 8.5372 12.7986C8.5774 12.7863 8.6148 12.7663 8.64725 12.7396C8.67971 12.7129 8.70658 12.6801 8.72634 12.643C8.7461 12.6059 8.75835 12.5653 8.7624 12.5235L9.31056 6.89533C9.31881 6.81086 9.29317 6.72658 9.23928 6.66101C9.18539 6.59545 9.10766 6.55398 9.0232 6.54573C8.98132 6.54136 8.939 6.54535 8.89868 6.55747C8.85836 6.56959 8.82085 6.5896 8.78833 6.61633C8.75581 6.64306 8.72892 6.67599 8.70922 6.7132C8.68953 6.75041 8.67742 6.79116 8.6736 6.83309L8.12544 12.4612C8.11718 12.5457 8.14282 12.63 8.19671 12.6956C8.2506 12.7611 8.32849 12.8026 8.41296 12.8108ZM4.55568 12.8124C4.60035 12.8125 4.64454 12.8032 4.68539 12.7851C4.72625 12.767 4.76287 12.7406 4.79289 12.7075C4.82291 12.6744 4.84567 12.6354 4.85971 12.593C4.87375 12.5506 4.87875 12.5057 4.8744 12.4612L4.32624 6.83309C4.3224 6.79117 4.31027 6.75043 4.29057 6.71323C4.27087 6.67603 4.24398 6.64311 4.21146 6.61638C4.17894 6.58965 4.14144 6.56964 4.10113 6.55751C4.06082 6.54539 4.01851 6.54138 3.97664 6.54573C3.89217 6.55398 3.81444 6.59545 3.76055 6.66101C3.70666 6.72658 3.68102 6.81086 3.68928 6.89533L4.23744 12.5235C4.24514 12.6025 4.28197 12.6759 4.34076 12.7293C4.39954 12.7827 4.47625 12.8123 4.55568 12.8124Z"
                                                  fill="#000000"
                                                />
                                              </svg>
                                            </div>
                                          </Link>
                                        ) : null}

                                        {community.status !== "pending" ? (
                                          <a
                                            style={{ cursor: "pointer" }}
                                            title="Upload document"
                                          >
                                            <div
                                              className="upload-btn-icon"
                                              onClick={() => {
                                                navigate(
                                                  "/admin/upload-document",
                                                  {
                                                    state: {
                                                      communityId:
                                                        community?.community
                                                          ?.id,
                                                      communityName:
                                                        community?.community
                                                          ?.community_name,
                                                    },
                                                  }
                                                );
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="14"
                                                viewBox="0 0 64 64"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 512 512",
                                                }}
                                              >
                                                <g>
                                                  <g data-name="Layer 51">
                                                    <path
                                                      d="M57.47 38.6a2 2 0 0 0-2 2v6.83a6.07 6.07 0 0 1-6.07 6.07H14.6a6.07 6.07 0 0 1-6.07-6.07V40.6a2 2 0 1 0-4 0v6.83A10.08 10.08 0 0 0 14.6 57.5h34.8a10.08 10.08 0 0 0 10.07-10.07V40.6a2 2 0 0 0-2-2z"
                                                      fill="#000000"
                                                    />
                                                    <path
                                                      d="m22 21.3 8-8V43a2 2 0 0 0 4 0V13.33l8 8a2 2 0 0 0 2.83-2.83L33.42 7.09a2.16 2.16 0 0 0-1-.55 2.06 2.06 0 0 0-1.81.55L19.2 18.47A2 2 0 0 0 22 21.3z"
                                                      fill="#000000"
                                                    />
                                                  </g>
                                                </g>
                                              </svg>
                                            </div>
                                          </a>
                                        ) : null}
                                        {community.status !== "pending" ? (
                                          <a
                                            style={{ cursor: "pointer" }}
                                            title="Add homeowner"
                                          >
                                            <div
                                              className="add-user-icon"
                                              // data-bs-toggle="modal"
                                              // data-bs-target="#homeowner"
                                              onClick={() => {
                                                if (
                                                  community?.is_subscribed ||
                                                  profileData?.is_super_subscribed ||
                                                  (profileData?.is_trial_activated &&
                                                    community?.community?.id ===
                                                      profileData?.trial_community &&
                                                    new Date(
                                                      profileData?.trial_ends_at
                                                    ) > new Date())
                                                ) {
                                                  setModalShow(true);
                                                  setId(
                                                    community?.community?.id
                                                  );
                                                } else {
                                                  setSelectedProductId(
                                                    securedDocProduct?.id
                                                  );
                                                  setShowSubscriptionModal(
                                                    true
                                                  );
                                                  setId(
                                                    community?.community?.id
                                                  );
                                                }
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                version="1.1"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="14"
                                                height="14"
                                                x="0"
                                                y="0"
                                                viewBox="0 0 512 512"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 512 512",
                                                }}
                                                xmlSpace="preserve"
                                                className=""
                                              >
                                                <g>
                                                  <path
                                                    d="M49.5 512c-11.046 0-20-8.954-20-20 0-100.355 81.645-182 182-182h30c20.537 0 40.703 3.4 59.937 10.105 10.43 3.636 15.938 15.04 12.301 25.469-3.636 10.43-15.04 15.938-25.469 12.301C273.278 352.65 257.543 350 241.5 350h-30c-78.299 0-142 63.701-142 142 0 11.046-8.954 20-20 20zm310-377c0-74.439-60.561-135-135-135s-135 60.561-135 135 60.561 135 135 135 135-60.561 135-135zm-40 0c0 52.383-42.617 95-95 95s-95-42.617-95-95 42.617-95 95-95 95 42.617 95 95zm143 257h-60v-60c0-11.046-8.954-20-20-20s-20 8.954-20 20v60h-60c-11.046 0-20 8.954-20 20s8.954 20 20 20h60v60c0 11.046 8.954 20 20 20s20-8.954 20-20v-60h60c11.046 0 20-8.954 20-20s-8.954-20-20-20z"
                                                    fill="#000000"
                                                    opacity="1"
                                                    data-original="#000000"
                                                    className=""
                                                  />
                                                </g>
                                              </svg>
                                            </div>

                                            <div
                                              className="modal fade"
                                              id="homeowner"
                                              tabIndex="-1"
                                              aria-labelledby="exampleModalLabel"
                                              aria-hidden="true"
                                            >
                                              <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content">
                                                  <div className="modal-header">
                                                    <h1
                                                      className="modal-title fs-5"
                                                      id="exampleModalLabel"
                                                    >
                                                      Add Home Owner
                                                    </h1>
                                                    <button
                                                      type="button"
                                                      className="btn-close"
                                                      data-bs-dismiss="modal"
                                                      aria-label="Close"
                                                    ></button>
                                                  </div>
                                                  <div className="modal-body">
                                                    <div className="search-bar-homeowner">
                                                      <div className="homeowner-innerwrap">
                                                        <div className="input-searchbar-community">
                                                          <div className="input-wrapper">
                                                            <div className="input-capsules">
                                                              <input
                                                                type="text"
                                                                value={
                                                                  inputValue
                                                                }
                                                                onChange={
                                                                  handleChange
                                                                }
                                                                onKeyDown={
                                                                  handleKeyDown
                                                                }
                                                                placeholder="Enter emails (and press enter)"
                                                                autoComplete="off"
                                                                className="email-input"
                                                              />
                                                              {emails.map(
                                                                (
                                                                  email,
                                                                  index
                                                                ) => (
                                                                  <div
                                                                    key={
                                                                      emails?.id
                                                                    }
                                                                    className="email-capsule"
                                                                  >
                                                                    {email}
                                                                    <button
                                                                      type="button"
                                                                      className="remove-btn"
                                                                      onClick={() =>
                                                                        handleRemoveEmail(
                                                                          index
                                                                        )
                                                                      }
                                                                    >
                                                                      <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        version="1.1"
                                                                        width="10"
                                                                        height="10"
                                                                        x="0"
                                                                        y="0"
                                                                        viewBox="0 0 64 64"
                                                                        style={{
                                                                          enableBackground:
                                                                            "new 0 0 512 512",
                                                                        }}
                                                                        className=""
                                                                      >
                                                                        <g>
                                                                          <path
                                                                            d="M4.59 59.41a2 2 0 0 0 2.83 0L32 34.83l24.59 24.58a2 2 0 0 0 2.83-2.83L34.83 32 59.41 7.41a2 2 0 0 0-2.83-2.83L32 29.17 7.41 4.59a2 2 0 0 0-2.82 2.82L29.17 32 4.59 56.59a2 2 0 0 0 0 2.82z"
                                                                            fill="#e55426"
                                                                            opacity="1"
                                                                            data-original="#e55426"
                                                                            className=""
                                                                          />
                                                                        </g>
                                                                      </svg>
                                                                    </button>
                                                                  </div>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="modal-footer">
                                                    <button
                                                      type="button"
                                                      className="btn-submit-claim"
                                                      data-bs-dismiss="modal"
                                                      onClick={() =>
                                                        handleHomeOwner(
                                                          community?.community
                                                            ?.id
                                                        )
                                                      }
                                                    >
                                                      {addmholoading
                                                        ? "Submitting..."
                                                        : "Submit"}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </a>
                                        ) : null}
                                        {/* {community.status !== "pending" ? (
                                          <div
                                            title="Compliance"
                                            style={{ cursor: "pointer" }}
                                            className={`red-checkmark-icon ${
                                              true
                                                ? "subscribed"
                                                : "unsubscribed"
                                            }`}
                                            onClick={() => {
                                              if (
                                                community?.is_compliance ||
                                                profileData?.is_super_subscribed ||
                                                (profileData?.is_trial_activated &&
                                                  community?.community?.id ===
                                                    profileData?.trial_community &&
                                                  new Date(
                                                    profileData?.trial_ends_at
                                                  ) > new Date())
                                              ) {
                                                // setModalShow(true);

                                                navigate("/admin/compliance", {
                                                  state: {
                                                    communityId:
                                                      community?.community?.id,
                                                    communityName:
                                                      community?.community
                                                        ?.community_name,
                                                  },
                                                });
                                                // setId(
                                                //   community?.community?.id
                                                // );
                                              } else {
                                                setSelectedProductId(
                                                  complianceProduct?.id
                                                );
                                                setShowSubscriptionModal(true);
                                                setId(community?.community?.id);
                                              }
                                            }}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              version="1.1"
                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                              width="20"
                                              height="20"
                                              x="0"
                                              y="0"
                                              viewBox="0 0 100 100"
                                              style={{
                                                enableBackground:
                                                  "new 0 0 512 512",
                                              }}
                                              xmlSpace="preserve"
                                              className=""
                                            >
                                              <g>
                                                <path
                                                  d="M31.535 72.231C39.849 59.45 70.43 26.55 95.79 9.457c1.077-.726 2.293.7 1.4 1.642-24.092 25.444-49.845 54.223-64.635 79.109-.412.693-1.406.717-1.837.035C23.276 78.455 16.893 61.51 3.211 56.316c-1.016-.386-.919-1.823.138-2.077 13.111-3.16 19.255 8.054 28.186 17.99v.002z"
                                                  fill="#ffffff"
                                                  opacity="1"
                                                />
                                              </g>
                                            </svg>
                                          </div>
                                        ) : // </Link>
                                        null} */}
                                      </div>
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan="8">
                                  🏡 Building your future, one community at a
                                  time! Your trial period will start as soon as
                                  the first community gets approved by the
                                  Superadmin. Let’s get started!
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                      <PaginationComponent
                        count={amCommunityCount}
                        pageSize={amPageSize}
                        setPageSize={setAmPageSize}
                        page={amPage}
                        setPage={setAmPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="all-commmunities-table">
          <div className="inner-wrap-all">
            <div className="title-search-block d-flex justify-content-between align-items-center">
              <div className="allcommunities">All Communities</div>
              <div className="searchbar">
                <input
                  type="search"
                  placeholder="Search..."
                  className="inputsearch"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="community-name-table communityblk">
              <div className="table-inner">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Community Name</th>
                      <th scope="col">City</th>
                      <th scope="col">State</th>
                      <th scope="col">Type</th>
                      <th scope="col" className="units-th">
                        Units
                      </th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {all_community_claim && all_community_claim.length > 0 ? (
                      all_community_claim.map((community, index) => (
                        <tr key={community.id}>
                          <td>
                            <Link
                              to={`/admin/tab/${encryptId(community?.id)}`}
                              className="table-community-name"
                            >
                              {capitalizeWords(community?.community_name)}
                            </Link>
                          </td>
                          <td>{community?.location?.city}</td>
                          <td>{community?.location?.state}</td>
                          <td>{community.type}</td>
                          <td>{community.unit}</td>
                          <td>
                            <button
                              className="orange-filled-btn claimbtn "
                              onClick={() => {
                                setSelectedCommunityId(community?.id);
                                handleSubmit(community?.id);
                                setIsLoading(true);
                              }}
                              disabled={isLoading}
                            >
                              Claim
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td>No records found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <PaginationComponent
                  count={count}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        id={id}
        handleSelFileChange={(e) => handleSelFileChange()}
      />
      <PurchaseSubscriptionModal
        show={showSubscriptionModal}
        id={id}
        onHide={() => setShowSubscriptionModal(false)}
        refetch={() => setRefetch(!refetch)}
        productId={selectedProductId}
      />
    </>
  );
}

function PurchaseSubscriptionModal(props) {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchProductList());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const res = await dispatch(
        createNewSubscription({
          user_id: userId,
          product_id: props.productId,
          community_id: props.id,
        })
      );

      if (res) {
        props.onHide();
        if (res?.payload?.status === 200) props.refetch();
        if (res?.payload?.data?.checkout_url)
          setTimeout(() => {
            window.location.href = res?.payload?.data?.checkout_url;
            const currentPage = window.location.pathname;
            localStorage.setItem("lastVisitedPage", currentPage);
          }, 500);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false); // Unlock the button
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="d-flex justify-content-center">
        <Modal.Title className="fw-bold">Subscription Required!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          {/* <h5 className="mb-3">Join the Community</h5> */}
          <p className="text-muted">
            Subscribe now to unlock exclusive access and add homeowners to your
            community.
          </p>
          {/* <img
            src="data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100' fill='blue'%3E%3Cpath d='M12 2L2 7v4c0 5.55 3.84 10.74 9.21 12 .26.06.53.06.79 0C18.16 21.74 22 16.55 22 11V7l-10-5z'/%3E%3C/svg%3E"
            alt="Subscription Icon"
            className="img-fluid my-3"
          /> */}
        </div>
      </Modal.Body>
      <Modal.Footer className="">
        <button className="bttn-close" onClick={props.onHide}>
          Close
        </button>
        {/* <button className="bttn-upload" onClick={() => navigate("/admin/subscriptions")}>
          Subscribe Now
        </button> */}
        <button className="bttn-upload" onClick={() => handleSubmit()}>
          Subscribe Now
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CommunityComp;
